import { mapState } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      running: state => state.aiSpeech.running
    })
  }
};